import React from "react";

  function MyCard9({ className = "", children ,onClick}) {
  return (
    <div
    onClick={() => onClick && onClick()}
      className={`w-full   ${className} rounded-xl backdrop-blur-sm bg-blue-700/10 dark:bg-blue-700/10  border border-input border-blue-600/30 dark:border-blue-600/30`}
    >
      {children}
    </div>
  );
}
export default MyCard9;
